export default __webpack_public_path__ + "static/media/5.35528e71.png";